import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import Icon from '../components/Icon';
import { actions as diagnosticMessagesActions } from '../diagnosticMessages/reducer';
import {
  actions as orderActions,
  initialState as orderInitialState,
  type State as OrderState,
} from '../order/reducers';
import history from '../util/history';
import { selectDisplayableMessages } from './selectors';

const DiagnosticMessages: React.FC = () => {
  const dispatch = useDispatch();
  const messages = useSelector(selectDisplayableMessages);

  const orderErrorKeys = Object.keys(orderInitialState.error);

  const handleClose = (id: string) => {
    if (id === 'editOrder') {
      if (window.confirm('Are you sure you want to stop editing this order?')) {
        dispatch(orderActions.exitEditOrder());
        history.push('/');
        return dispatch(orderActions.dismissError({ key: id }));
      }
      return;
    }
    if (orderErrorKeys.includes(id)) {
      return dispatch(orderActions.dismissError({ key: id as keyof OrderState['error'] }));
    } else {
      return dispatch(diagnosticMessagesActions.removeMessage({ id }));
    }
  };

  return (
    <StyledDiagnosticMessages>
      {messages.map((message) => (
        <div className={message.type} key={message.id}>
          <div className="message-icon">
            <Icon>{message.type}</Icon>
            {message.text}
          </div>
          {message.dismissible && (
            <button className="close-button" onClick={() => handleClose(message.id)}>
              <Icon className="close">close</Icon>
            </button>
          )}
        </div>
      ))}
    </StyledDiagnosticMessages>
  );
};

const StyledDiagnosticMessages = styled.div`
  position: sticky;
  top: 82px;
  width: 100%;
  z-index: 1000;

  & > div {
    font: ${(props) => props.theme.smallBoldFont};
    margin: 7px;
    padding: 7px;
    line-height: 19px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  & .error {
    color: ${(props) => props.theme.colors.error};
    border: 1px solid ${(props) => props.theme.colors.error};
    background-color: #ffe8e6;
  }

  & .warning {
    color: ${(props) => props.theme.colors.warning};
    border: 1px solid ${(props) => props.theme.colors.warning};
    background-color: #fffcee;
  }

  & .message-icon {
    flex: 40;
  }

  & .message-icon svg {
    width: 19px;
    float: left;
    max-height: 20px;
    margin: 0 5px;
  }

  & .close-button {
    flex: 1;
    background: transparent;
    border: transparent;
    width: 25px;
  }

  & .close-button svg {
    fill: ${(props) => props.theme.colors.outline};
    margin: 0;
    width: 20px;
    height: 20px;
  }

  & .close-button:hover {
    cursor: pointer;
  }
`;

export default DiagnosticMessages;
